import { useMemo } from 'react';

import usePanelDataService from '../../../services/PanelDataService';
import PerformanceMinMax from '../../charts/performance-min-max/PerformanceMinMax';
import { uiPerformanceTest } from './UiPerformanceTest';

const dataSourceFn = (search) => {
    const searchParam = search ? { search } : {};
    return {
        url: '/query/testLog',
        totalProperty: 'count',
        params: {
            ...searchParam,
            type: 'test,agent',
            test: 'UIPerformance',
            metrics: 'testTime,avgloadtime,avgrequests,avgresponsessize,pagename',
            trends: 'avgloadtime,maxloadtime,minloadtime',
            searchFields: 'pagename',
        },
    };
};

export default function UiPerformanceChart(props) {
    const { search } = props;
    const dataSource = useMemo(() => dataSourceFn(search), [search]);
    const uiPerformanceResponse = usePanelDataService(dataSource);

    if (!uiPerformanceResponse) return null;

    const { trends } = uiPerformanceResponse;
    const data = {
        trends,
        avgloadtime: trends.avgloadtime?.value,
        maxloadtime: trends.maxloadtime?.value,
        minloadtime: trends.minloadtime?.value,
    };
    return <PerformanceMinMax test={uiPerformanceTest} tableData={data} chartData={data} />;
}
